<template>
  <v-container>
    <h1>Slider</h1>

    <!-- Page Selection -->
    <v-row>
      <v-col cols="12">
        <v-select v-model="pageData.type" :items="pageTypes" label="Type de page" item-text="name" item-value="value"
          @change="onPageTypeChange"></v-select>
      </v-col>
    </v-row>

    <!-- Dynamic Content Based on Page Type -->
    <template v-if="pageData.type">
      <!-- LIENEXTERNE Specific Content -->
      <template v-if="pageData.type === 'LIENEXTERNE'">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="pageData.link" label="Saisir le lien"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="pageData.buttonTitle" label="Saisir le texte du bouton"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="pageData.buttonTitleEn" label="Saisir le texte du bouton (EN)"></v-text-field>
          </v-col>
        </v-row>
      </template>

      <!-- PREMIUM Specific Content -->
      <template v-else-if="pageData.type === 'PREMIUM'">
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="pageData.buttonTitle" label="Saisir le texte du bouton"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="pageData.buttonTitleEn" label="Saisir le texte du bouton (EN)"></v-text-field>
          </v-col>
        </v-row>
      </template>

      <!-- Other Pages Content -->
      <template v-else>
        <!-- Sélecteur de sous-catégorie si disponible -->
        <v-row v-if="subCategories && subCategories.length > 0">
          <v-col cols="12" md="6">
            <v-select v-model="selectedSubCategoryId" :items="subCategories" :item-text="subCategoryItemText"
              item-value="id" label="Sélectionner une série" :loading="loadingSubCategories"
              @change="onSubCategoryChange" clearable></v-select>
          </v-col>
        </v-row>

        <v-row v-else-if="showThemeSelector">
          <v-col cols="12" md="6">
            <v-select v-model="selectedTheme" :items="currentThemeOptions" label="Sélectionner un thème"
              @change="onThemeChange"></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col v-if="dataFromApi || loadingActualities" cols="12" md="4">
            <v-select v-model="selectedItem" :items="dataFromApi || []" :item-text="itemText" item-value="id"
              label="Sélectionner un élément" :loading="loadingActualities" :disabled="loadingActualities"
              no-data-text="Aucun élément trouvé" return-object></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="pageData.buttonTitle" label="Saisir le texte du bouton"></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field v-model="pageData.buttonTitleEn" label="Saisir le texte du bouton (EN)"></v-text-field>
          </v-col>
        </v-row>
      </template>

      <!-- Image Uploads -->
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-progress-circular v-if="loadingImage1" :size="50" color="primary" indeterminate></v-progress-circular>
          <vue-upload-multiple-image :idUpload="imagesId" v-model="images" :data-images="images" accept="image/*"
            name="images" drag-text="Veuillez ajouter une image theme light!" browse-text="Browse image"
            @upload-success="uploadImageSuccess" :min-image="1" :multiple="false"
            @before-remove="beforeRemove"></vue-upload-multiple-image>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-progress-circular v-if="loadingImage2" :size="50" color="primary" indeterminate></v-progress-circular>
          <vue-upload-multiple-image :idUpload="imagesIdBanner" v-model="imagesBanner" :data-images="imagesBanner"
            accept="image/*" name="imagesBanner" drag-text="Veuillez ajouter une image theme Dark!" browse-text="Browse image"
            @upload-success="uploadImageSuccessBanner" :showEdit="false" :multiple="false"
            @before-remove="beforeRemove"></vue-upload-multiple-image>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-progress-circular v-if="loadingImage3" :size="50" color="primary" indeterminate></v-progress-circular>
          <vue-upload-multiple-image :idUpload="imagesId2" v-model="imagesEn" :data-images="imagesEn" accept="image/*"
            name="imagesEn" drag-text="Veuillez ajouter une image theme light (EN)!" browse-text="Browse image"
            @upload-success="uploadImageSuccessEn" :min-image="1" :multiple="false"
            @before-remove="beforeRemove"></vue-upload-multiple-image>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-progress-circular v-if="loadingImage4" :size="50" color="primary" indeterminate></v-progress-circular>
          <vue-upload-multiple-image :idUpload="imagesIdBanner2" v-model="imagesBannerEn" :data-images="imagesBannerEn"
            accept="image/*" name="imagesBannerEn" drag-text="Veuillez ajouter une image theme Dark (EN)!" browse-text="Browse image"
            @upload-success="uploadImageSuccessBannerEn" :showEdit="false" :multiple="false"
            @before-remove="beforeRemove"></vue-upload-multiple-image>
        </v-col>
      </v-row>
    </template>

    <!-- Save Button -->
    <v-row>
      <v-col cols="12" md="6">
        <v-btn :loading="btnLoading" color="info" @click.prevent="save">
          Enregistrer
        </v-btn>
        <small v-if="errorMessage" class="error--text">{{ errorMessage }}</small>

      </v-col>
    </v-row>

    <!-- Notification -->
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:actions>
        <v-btn color="blue" variant="text" @click="snackbar = false">
          Fermer
        </v-btn>
      </template>
    </v-snackbar>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des Pages</v-card-title>

      <v-data-table no-data-text="noDataText" loading-text="Loading..." :headers="headers" :items="listPage"
        class="elevation-1" item-key="id" show-expand single-expand>
        <template v-slot:[`item.imgUrlLight`]="{ item }">
          <v-img v-if="item.fileType != 'svg'" :src="item.imgUrlLight" width="65" height="65" />
          <div v-if="item.fileType == 'svg'" v-html="item.svgContentLight"></div>
        </template>
        <template v-slot:[`item.imgUrlDark`]="{ item }">
          <v-img v-if="item.fileDarkType != 'svg'" :src="item.imgUrlDark" width="65" height="65" />
          <div v-if="item.fileDarkType == 'svg'" v-html="item.svgContentDark"></div>
        </template>
        <template v-slot:[`item.attributes`]="{ item }">
          <div v-if="item.type === 'RECITATEUR'">
            {{ item.recitateurName }}
          </div>
          <div v-else-if="item.type === 'THEME'">
            {{ item.themeName }}
          </div>
          <div v-else-if="item.type === 'DUAA'">
            {{ item.dossierName }}
          </div>
          <div v-else-if="item.type === 'LIENEXTERNE'">
            {{ item.route }}
          </div>
          <div v-else-if="item.dossierName">
            {{ item.dossierName }}
          </div>
        </template>
        <template v-slot:[`item.modifier`]="{ item }">
          <v-btn color="primary" small @click="editItem(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.supprimer`]="{ item }">
          <v-btn color="error" small @click="deleteItem(item)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="expanded-row-details">
            <v-container fluid>
              <v-row>
                <v-col cols="12" md="6">
                  <div class="detail-item">
                    <span class="detail-label">Image Light EN :</span>
                    <v-img v-if="item.fileTypeEn != 'svg'" :src="item.imgUrlLightEn" max-width="200" />
                    <div v-if="item.fileTypeEn == 'svg'" v-html="item.svgContentLightEn" style="max-width: 200px;">
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="detail-item">
                    <span class="detail-label">Image Dark EN :</span>
                    <v-img v-if="item.fileDarkTypeEn != 'svg'" :src="item.imgUrlDarkEn" max-width="200" />
                    <div v-if="item.fileDarkTypeEn == 'svg'" v-html="item.svgContentDarkEn" style="max-width: 200px;">
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="detail-item">
                    <span class="detail-label">Titre du bouton (EN) :</span>
                    <span class="detail-value">{{ item.titleEn || "-" }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </td>
        </template>
      </v-data-table>

    </v-card>
  </v-container>
</template>

<script>
import {
  getAllTheme,
  getAllduaa,
  getAllRecitateur,
  getActualityByCategory,
  getAllPage,
  getRecitateurById,
  getThemeById,
  getActualiteById,
  getDuaaById,
  FetchActualityByCategoryAndSubCategory,
  FetchAllSubCategoriesByCategoryId,
} from "@/views/qorani/services/services";
import store from "@/store/image";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import axios from "axios";
import constants from "@/utils/constants";

export default {
  components: { VueUploadMultipleImage },

  data() {
    return {
      url: constants.QORANI,
      showEnglishImages: false,
      headers: [
        { text: "ImageLight", value: "imgUrlLight" },
        { text: "ImageDark", value: "imgUrlDark" },
        { text: "Titre", value: "title" },
        { text: "Type", value: "type" },
        { text: "attributes", value: "attributes" },
        { text: "", value: "data-table-expand" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      listPage: [],
      btnLoading: false,
      loadingImage1: false,
      loadingImage2: false,
      loadingImage3: false,
      loadingImage4: false,
      imagesId: "0",
      imagesIdBanner: "1",
      imagesId2: "2",
      imagesIdBanner2: "3",
      snackbar: false,
      text: "",
      timeout: 4000,
      images: [],
      errorMessage: null,
      imagesBanner: [],
      imagesEn: [],
      imagesBannerEn: [],
      pageData: {
        buttonTitle: '',
        buttonTitleEn: '',
        fileId: null,
        fileDarkId: null,
        fileIdEn: null,
        fileDarkIdEn: null,
        type: '',
        recitateurId: null,
        actualityId: null,
        themeId: null,
        duaaId: null,
        link: null
      },
      selectedItem: null,
      selectedTheme: "",
      dataFromApi: null,
      itemText: "title",
      pageTypes: [],
      subCategories: [],
      selectedSubCategoryId: null,
      loadingSubCategories: false,
      loadingActualities: false,
      themeOptions: {
        VJHJSV: ['VERSET_DU_JOUR', 'HADITH_DU_JOUR', 'LE_SAVIEZ_VOUS'],
        PHPT: ['PERSONNAGE', 'PATRIMOINE']
      },
      categories: [],
    };
  },

  computed: {
    isFormValid() {
      if (!this.pageData.type) return false;
      if (!this.pageData.buttonTitle
        || !this.pageData.buttonTitleEn
        || !this.pageData.fileId
        || !this.pageData.fileDarkId
        || !this.pageData.fileIdEn
        || !this.pageData.fileDarkIdEn
      ) return false;

      switch (this.pageData.type) {
        case 'LIENEXTERNE':
          return !!this.pageData.link;
        case 'PREMIUM':
          return true;
        case 'RECITATEUR':
          return !!(this.selectedItem && (this.selectedItem.recitateurId || this.selectedItem.id));
        case 'THEME':
        case 'DUAA':
          return !!(this.selectedItem && this.selectedItem.id);
        default:
          if (this.subCategories && this.subCategories.length > 0 && !this.selectedSubCategoryId) {
            return false;
          }
          return !!(this.selectedItem && this.selectedItem.id);
      }
    },

    showThemeSelector() {
      return ['VJHJSV', 'PHPT'].includes(this.pageData.type) && (!this.subCategories || this.subCategories.length === 0);
    },

    currentThemeOptions() {
      if (this.pageData.type === 'VJHJSV') return this.themeOptions.VJHJSV || [];
      if (this.pageData.type === 'PHPT') return this.themeOptions.PHPT || [];
      return [];
    },

  },

  methods: {
    async loadCategories() {
      try {
        let res = await axios.get(`${constants.QORANI}actualityCategory/getall`);
        this.pageTypes = res.data.map(category => ({
          id: category.id,
          name: category.label,
          value: category.category || category.label,
          subcategories: category.subCategoryList || []
        }));
        this.pageTypes.unshift({ name: "RECITATEUR", value: "RECITATEUR", subcategories: [] });
        this.pageTypes.push(
          { name: "THEME", value: "THEME", subcategories: [] },
          { name: "DUAA", value: "DUAA", subcategories: [] },
          { name: "PREMIUM", value: "PREMIUM", subcategories: [] },
          { name: "LIENEXTERNE", value: "LIENEXTERNE", subcategories: [] }
        );
      } catch (error) {
        console.error("Erreur lors du chargement des catégories:", error);
      }
    },
    async loadImage(item) {
      // Charger l'image light si elle existe
      if (item.fileId && item.fileType) {
        try {
          if (item.fileType === "svg") {
            const response = await fetch(
              `${constants.QORANI}fileDB/files/${item.fileId}`
            );
            if (!response.ok) throw new Error("Échec du chargement de l'image SVG light");

            let svgContent = await response.text();

            // Ajoute width et height directement dans le SVG
            svgContent = svgContent
              .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
              .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
              .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

            this.$set(item, 'svgContentLight', svgContent);
          } else {
            console.log(`${constants.QORANI}fileDB/files/${item.fileId}`);
            this.$set(item, 'imgUrlLight', `${constants.QORANI}fileDB/files/${item.fileId}`);
          }
        } catch (error) {
          console.error("Erreur lors du chargement de l'image light :", error);
        }
      }

      // Charger l'image dark si elle existe
      if (item.fileDarkId && item.fileDarkType) {
        try {
          if (item.fileDarkType === "svg") {
            const response = await fetch(
              `${constants.QORANI}fileDB/files/${item.fileDarkId}`
            );
            if (!response.ok) throw new Error("Échec du chargement de l'image SVG dark");

            let svgContent = await response.text();

            // Ajoute width et height directement dans le SVG
            svgContent = svgContent
              .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
              .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
              .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');
            this.$set(item, 'svgContentDark', svgContent);
            console.log(item.svgContentDark);

          } else {
            this.$set(item, 'imgUrlDark', `${constants.QORANI}fileDB/files/${item.fileDarkId}`);
          }
        } catch (error) {
          console.error("Erreur lors du chargement de l'image dark :", error);
        }
      }

      // Charger l'image light EN si elle existe
      if (item.fileIdEn && item.fileTypeEn) {
        try {
          if (item.fileTypeEn === "svg") {
            const response = await fetch(
              `${constants.QORANI}fileDB/files/${item.fileIdEn}`
            );
            if (!response.ok) throw new Error("Échec du chargement de l'image SVG light EN");

            let svgContent = await response.text();

            // Ajoute width et height directement dans le SVG
            svgContent = svgContent
              .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
              .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
              .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');

            this.$set(item, 'svgContentLightEn', svgContent);
          } else {
            console.log(`${constants.QORANI}fileDB/files/${item.fileIdEn}`);
            this.$set(item, 'imgUrlLightEn', `${constants.QORANI}fileDB/files/${item.fileIdEn}`);
          }
        } catch (error) {
          console.error("Erreur lors du chargement de l'image light EN :", error);
        }
      }

      // Charger l'image dark EN si elle existe
      if (item.fileDarkIdEn && item.fileDarkTypeEn) {
        try {
          if (item.fileDarkTypeEn === "svg") {
            const response = await fetch(
              `${constants.QORANI}fileDB/files/${item.fileDarkIdEn}`
            );
            if (!response.ok) throw new Error("Échec du chargement de l'image SVG dark EN");

            let svgContent = await response.text();

            // Ajoute width et height directement dans le SVG
            svgContent = svgContent
              .replace(/(<svg[^>]*)\swidth="[^"]*"/i, "$1")
              .replace(/(<svg[^>]*)\sheight="[^"]*"/i, "$1")
              .replace(/(<svg[^>]*)>/i, '$1 width="65" height="65">');
            this.$set(item, 'svgContentDarkEn', svgContent);
            console.log(item.svgContentDarkEn);

          } else {
            this.$set(item, 'imgUrlDarkEn', `${constants.QORANI}fileDB/files/${item.fileDarkIdEn}`);
          }
        } catch (error) {
          console.error("Erreur lors du chargement de l'image dark EN :", error);
        }
      }
    },

    async deleteItem(item) {
      try {
        if (confirm("Êtes-vous sûr de vouloir supprimer cette page ?")) {
          await axios.get(`${constants.QORANI}page/delete/${item.id}`);
          this.showMessage("Page supprimée avec succès", "success");
          // Recharger la liste des pages
          this.listPage = await getAllPage();
        }
      } catch (error) {
        console.error("Erreur lors de la suppression:", error);
        this.showMessage("Erreur lors de la suppression", "error");
      }
    },
    async getRecitateurById(id) {
      const res = await getRecitateurById(id)
      console.log(res.name);

      return res.name
    },

    async editItem(item) {
      try {
        // Réinitialiser le formulaire
        this.resetForm();

        // Remplir les données de base
        this.pageData = {
          id: item.id,
          update: true,
          ...this.pageData,
          buttonTitle: item.title,
          buttonTitleEn: item.titleEn,
          fileId: item.fileId,
          fileDarkId: item.fileDarkId,
          fileIdEn: item.fileIdEn,
          fileDarkIdEn: item.fileDarkIdEn,
          type: item.type,
          link: item.type === 'LIENEXTERNE' ? item.route : null
        };

        // Charger les images existantes
        if (item.fileId) {
          this.images = [{
            path: `${this.url}fileDB/files/${item.fileId}`
          }];
        }
        if (item.fileDarkId) {
          this.imagesBanner = [{
            path: `${this.url}fileDB/files/${item.fileDarkId}`
          }];
        }
        if (item.fileIdEn) {
          this.imagesEn = [{
            path: `${this.url}fileDB/files/${item.fileIdEn}`
          }];
        }
        if (item.fileDarkIdEn) {
          this.imagesBannerEn = [{
            path: `${this.url}fileDB/files/${item.fileDarkIdEn}`
          }];
        }

        // Gérer le type de page et les données associées
        if (item.type && !['PREMIUM', 'LIENEXTERNE'].includes(item.type)) {
          if (['RECITATEUR', 'THEME', 'DUAA'].includes(item.type)) {
            await this.fetchData(item.type);
            switch (item.type) {
              case 'RECITATEUR':
                this.selectedItem = this.dataFromApi?.find(r => (r.recitateurId || r.id) === (item.recitateurId || item.attributes?.recitateurId));
                break;
              case 'THEME':
                this.selectedItem = this.dataFromApi?.find(t => t.id === (item.themeId || item.attributes?.themeId));
                break;
              case 'DUAA':
                this.selectedItem = this.dataFromApi?.find(d => d.id === (item.duaaId || item.attributes?.duaaId));
                break;
            }
          } else {
            // Catégorie d'actualité
            const actId = item.actualityId || item.attributes?.actualityId;
            let actuality = null;
            if (actId) {
              try {
                actuality = await getActualiteById(actId);
              } catch (e) {
                console.error("Erreur récupération actualité par ID:", e);
              }
            }

            const catObj = this.pageTypes.find(p => p.value === item.type || p.name === item.type);
            this.subCategories = catObj?.subcategories ? [...catObj.subcategories] : [];
            if (this.subCategories.length === 0 && catObj?.id) {
              try {
                const subs = await FetchAllSubCategoriesByCategoryId(catObj.id);
                if (subs && subs.length) {
                  this.subCategories = subs;
                }
              } catch (e) {
                console.error(e);
              }
            }

            const subId = actuality?.actualitySubCategoryId || actuality?.actualitySubCategoryEntity?.id;
            if (subId) {
              this.selectedSubCategoryId = subId;
              await this.onSubCategoryChange(subId);
              if (this.dataFromApi && actId) {
                this.selectedItem = this.dataFromApi.find(a => a.id === actId);
              }
            } else if (this.showThemeSelector) {
              this.selectedTheme = item.attributes?.category || '';
              if (this.selectedTheme) {
                await this.onThemeChange();
                if (this.dataFromApi && actId) {
                  this.selectedItem = this.dataFromApi.find(a => a.id === actId);
                }
              }
            } else {
              await this.fetchData(item.type);
              if (this.dataFromApi && actId) {
                this.selectedItem = this.dataFromApi.find(a => a.id === actId);
              }
            }
          }
        }
      } catch (error) {
        console.error("Erreur lors du chargement des données pour modification:", error);
        this.showMessage("Erreur lors du chargement des données", "error");
      }
    },
    async save() {
      this.errorMessage = null;

      if (!this.isFormValid) {
        this.errorMessage = "Veuillez remplir tous les champs obligatoires";
        return;
      }

      try {
        this.btnLoading = true;
        const isActuality = !['RECITATEUR', 'THEME', 'DUAA', 'PREMIUM', 'LIENEXTERNE'].includes(this.pageData.type);
        console.log(" page type : ", this.pageData.type, " isActuality : ", isActuality);

        const payload = {
          buttonTitle: this.pageData.buttonTitle,
          buttonTitleEn: this.pageData.buttonTitleEn,
          fileId: this.pageData.fileId,
          fileDarkId: this.pageData.fileDarkId,
          fileIdEn: this.pageData.fileIdEn,
          fileDarkIdEn: this.pageData.fileDarkIdEn,
          type: isActuality ? "DOSSIER" : this.pageData.type,
          recitateurId: this.pageData.type === 'RECITATEUR' ? (this.selectedItem?.recitateurId || this.selectedItem?.id) : null,
          actualityId: isActuality ? this.selectedItem?.id : null,
          themeId: this.pageData.type === 'THEME' ? this.selectedItem?.id : null,
          duaaId: this.pageData.type === 'DUAA' ? this.selectedItem?.id : null,
          link: this.pageData.type === 'LIENEXTERNE' ? this.pageData.link : null
        };

        // Si vous avez un ID dans pageData, c'est une mise à jour
        /*
        if (this.pageData.update) {
          await axios.post(`${constants.QORANI}page/edit/${this.pageData.id}`, payload);
          if (this.pageData.type != "PREMIUM") {
            await axios.post(`${constants.QORANI}library/generalSetting/edit/1`, {
              pageId: this.pageData.id,
            })
          }
          else {
            await axios.post(`${constants.QORANI}library/generalSetting/edit/1`, {
              pageNoPremiumId: this.pageData.id,
            })
          }

          this.showMessage("Page mise à jour avec succès", "success");
        } else {
          console.log(payload);

          let res = await axios.post(`${constants.QORANI}page/add`, payload);
          console.log(res.data.id);
          console.log(res.data.type);
          if (res.data.type != "PREMIUM") {
            await axios.post(`${constants.QORANI}library/generalSetting/edit/1`, {
              pageId: res.data.id,
            })
          }
          else {
            await axios.post(`${constants.QORANI}library/generalSetting/edit/1`, {
              pageNoPremiumId: res.data.id,
            })
          }

          this.showMessage("Page créée avec succès", "success");
          location.reload();
        }
*/
        this.resetForm();
      } catch (error) {
        console.error("Erreur:", error);
        this.showMessage("Erreur lors de l'opération", "error");
      } finally {
        this.btnLoading = false;
      }
    },

    async onPageTypeChange(val) {
      console.log("onPageTypeChange:", val);

      const selectedType = typeof val === 'object' && val !== null
        ? val
        : this.pageTypes.find(p => p.value === val || p.name === val);

      const typeValue = selectedType ? selectedType.value : val;

      this.resetForm();
      this.pageData.type = typeValue;
      this.selectedSubCategoryId = null;
      this.subCategories = (selectedType && selectedType.subcategories) ? [...selectedType.subcategories] : [];

      // Si c'est une catégorie d'actualité et la liste de sous-catégories est vide, tentative de chargement via API
      if (
        selectedType &&
        selectedType.id &&
        !['RECITATEUR', 'THEME', 'DUAA', 'PREMIUM', 'LIENEXTERNE'].includes(typeValue) &&
        this.subCategories.length === 0
      ) {
        try {
          this.loadingSubCategories = true;
          const subs = await FetchAllSubCategoriesByCategoryId(selectedType.id);
          if (subs && subs.length) {
            this.subCategories = subs;
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des sous-catégories:", error);
        } finally {
          this.loadingSubCategories = false;
        }
      }
      if (!['PREMIUM', 'LIENEXTERNE'].includes(typeValue)) {
        if (this.subCategories.length === 0 && !this.showThemeSelector) {
          await this.fetchData(typeValue);
        }
      }
    },

    async onSubCategoryChange(subCategoryId) {
      this.selectedItem = null;
      this.dataFromApi = null;
      if (!subCategoryId) return;

      try {
        this.loadingActualities = true;
        this.itemText = "title";
        const categoryCode = this.pageData.type;
        const res = await FetchActualityByCategoryAndSubCategory(categoryCode, subCategoryId);
        this.dataFromApi = Array.isArray(res) ? res : (res?.actualityMultiTypes || res?.content || []);
      } catch (error) {
        console.error("Erreur lors de la récupération des actualités:", error);
        this.showMessage("Erreur lors de la récupération des actualités", "error");
      } finally {
        this.loadingActualities = false;
      }
    },

    subCategoryItemText(item) {
      if (!item) return '';
      return item.label || item.labelEn || item.title || item.name || '';
    },

    async onThemeChange() {
      if (!this.selectedTheme) return;
      console.log("Selected theme:", this.selectedTheme);
      this.dataFromApi = await getActualityByCategory(this.selectedTheme);
      this.pageData.actualityId = null;
      this.selectedItem = null;
    },

    async fetchData(pageType) {
      this.dataFromApi = null;
      this.selectedItem = null;

      try {
        this.loadingActualities = true;
        switch (pageType) {
          case 'THEME':
            this.dataFromApi = await getAllTheme();
            this.itemText = "title";
            break;
          case 'DUAA':
            this.dataFromApi = await getAllduaa();
            this.itemText = "title";
            break;
          case 'RECITATEUR':
            this.dataFromApi = await getAllRecitateur();
            this.itemText = "name";
            break;
          default:
            this.itemText = "title";
            if (this.showThemeSelector && this.selectedTheme) {
              this.dataFromApi = await getActualityByCategory(this.selectedTheme);
            } else {
              this.dataFromApi = await getActualityByCategory(pageType);
            }
            break;
        }
      } catch (error) {
        console.error("Erreur lors du chargement des données:", error);
      } finally {
        this.loadingActualities = false;
      }
    },
    beforeRemove(index, done, fileList) {
      this.showlowding = false;
      this.fakePercentage = 0;
      this.uploadPercentage = 0;
      const r = confirm("remove image");
      if (r === true) {
        done();
      }
    },
    async uploadImageSuccess(formData, index, fileList) {
      try {
        this.loadingImage1 = true;
        await store.dispatch("uploadImageSuccess", { formData, index, fileList });
        this.pageData.fileId = store.state.imageId;
      } catch (error) {
        console.error("Erreur upload image:", error);
      } finally {
        this.loadingImage1 = false;
      }
    },

    async uploadImageSuccessBanner(formData, index, fileList) {
      try {
        this.loadingImage2 = true;
        await store.dispatch("uploadImageSuccessBanner", { formData, index, fileList });
        this.pageData.fileDarkId = store.state.imageIdBanner;
      } catch (error) {
        console.error("Erreur upload bannière:", error);
      } finally {
        this.loadingImage2 = false;
      }
    },

    async uploadImageSuccessEn(formData, index, fileList) {
      try {
        this.loadingImage3 = true;
        await store.dispatch("uploadImageSuccess", { formData, index, fileList });
        this.pageData.fileIdEn = store.state.imageId;
      } catch (error) {
        console.error("Erreur upload image EN:", error);
      } finally {
        this.loadingImage3 = false;
      }
    },

    async uploadImageSuccessBannerEn(formData, index, fileList) {
      try {
        this.loadingImage4 = true;
        await store.dispatch("uploadImageSuccessBanner", { formData, index, fileList });
        this.pageData.fileDarkIdEn = store.state.imageIdBanner;
      } catch (error) {
        console.error("Erreur upload bannière EN:", error);
      } finally {
        this.loadingImage4 = false;
      }
    },

    showMessage(message, type = "success") {
      this.text = message;
      this.snackbar = true;
      if (type === "error") {
        // Optionally add error styling
      }
    },

    resetForm() {
      this.images = [];
      this.imagesBanner = [];
      this.imagesEn = [];
      this.imagesBannerEn = [];
      this.selectedItem = null;
      this.selectedTheme = "";
      this.subCategories = [];
      this.selectedSubCategoryId = null;
      this.dataFromApi = null;
      this.pageData = {
        ...this.pageData,
        buttonTitle: '',
        buttonTitleEn: '',
        fileId: null,
        fileDarkId: null,
        fileIdEn: null,
        fileDarkIdEn: null,
        recitateurId: null,
        actualityId: null,
        themeId: null,
        duaaId: null,
        link: null,
        update: false,
        id: null
      };
    },
    async loadData() {
      this.isLoadingTables = true;
      try {
        // 1. Charger les données principales
        this.listPage = await getAllPage();

        // 2. Précharger les données associées et les images pour chaque élément
        await Promise.all(this.listPage.map(async (el) => {
          // Chargement des données spécifiques selon le type
          switch (el.type) {
            case 'RECITATEUR':
              if (el.attributes?.recitateurId) {
                const res = await getRecitateurById(el.attributes.recitateurId);
                el.recitateurName = res.name;
              }
              break;

            case 'DUAA':
              if (el.attributes?.duaaId) {
                const res = await getDuaaById(el.attributes.duaaId);
                el.dossierName = res.title;
              }
              break;

            case 'THEME':
              if (el.attributes?.themeId) {
                const res = await getThemeById(el.attributes.themeId);
                el.themeName = res.title;
              }
              break;

            case 'DOSSIER':
            case 'VJHJSV':
            case 'PHPT':
            default:
              if (el.attributes?.actualityId) {
                const res = await getActualiteById(el.attributes.actualityId);
                el.dossierName = res?.title;
              }
              break;
          }

          // Charger les images (light et dark) pour chaque élément
          await this.loadImage(el);
        }));

        // 3. Forcer la mise à jour réactive

        this.listPage = [...this.listPage.reverse()];

      } catch (error) {
        console.error("Erreur de chargement des données", error);
        this.loadError = true;
      } finally {
        this.isLoadingTables = false;
      }
    },
  },
  created() {
    Promise.all([this.loadCategories(), this.loadData()])
      .catch(error => {
        console.error("Erreur lors du chargement initial:", error);
      });
  },
};
</script>